/**
 * アプリケーションエントリーポイント
 * 純ReactのWebアプリとして来場者ルートを表示します。
 */

import React from "react";
import AppNavigator from "./src/navigation/AppNavigator";
import "./global.css";

/**
 * アプリケーションルートコンポーネント
 * @returns {JSX.Element} アプリケーション
 */
export default function App() {
  return <AppNavigator />;
}
